import React from "react";
import * as S from "./styled";

function Divider() {
  return <S.GoldLine />;
}

export default Divider;
